import Button from '../Button/Button';
import React from 'react';

const ResetFiltersButton: React.FC<{
  setFilters: (values: any) => void;
}> = ({ setFilters }) => (
  <Button
    variant="outline"
    icon="undo"
    onClick={() => setFilters(null)}
    title="Reset Form"
  />
);

export default ResetFiltersButton;
